module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_vestfold_telemark_pos.60a16d9b.svg";